import { createSlice } from '@reduxjs/toolkit';
import set from 'lodash/set';
import { RequestStatus } from '../types/index.js';
import '../checkout-Ee1eEXQH.js';
import '../menu-0TyOg98i.js';
import '../product-_pRduMz7.js';
import '../modal-6vnX5SO3.js';

// This slice is using as a wrapper for getting thunk loading statuses
const isPendingAction = (action) => action.type.endsWith(RequestStatus.Pending);
const isFulfilledAction = (action) => action.type.endsWith(RequestStatus.Fulfilled);
const isRejectedAction = (action) => action.type.endsWith(RequestStatus.Rejected);
const getThunkName = (actionType, sliceName) => {
    const actionTypeSplitted = actionType.split('/');
    if (actionTypeSplitted[0] === sliceName) {
        return actionTypeSplitted[1];
    }
    return null;
};
const createGenericSlice = ({ name, initialState, reducers, extraReducers, }) => createSlice({
    name,
    initialState: {
        ...initialState,
        requestStatuses: {},
    },
    reducers,
    extraReducers: builder => {
        extraReducers(builder);
        builder.addMatcher(isPendingAction, (state, action) => {
            const thunkName = getThunkName(action.type, name);
            if (thunkName) {
                set(state, ['requestStatuses', thunkName], RequestStatus.Pending);
            }
        });
        builder.addMatcher(isFulfilledAction, (state, action) => {
            const thunkName = getThunkName(action.type, name);
            if (thunkName) {
                set(state, ['requestStatuses', thunkName], RequestStatus.Fulfilled);
            }
        });
        builder.addMatcher(isRejectedAction, (state, action) => {
            const thunkName = getThunkName(action.type, name);
            if (thunkName) {
                set(state, ['requestStatuses', thunkName], RequestStatus.Rejected);
            }
        });
    },
});

export { createGenericSlice };
//# sourceMappingURL=genericSlice.js.map
